import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface HoursSelectProps {
  value: string;
  onChange: (event: SelectChangeEvent, child: React.ReactNode) => void;
  type: 'jobSize' | 'perWeek';
}

const maxHours = 40;
const hourItemSteps = Array.from({ length: maxHours }, (_, i) =>
  (i + 1).toString(),
);

export default function HoursSelect({
  value,
  onChange,
  type,
}: HoursSelectProps) {
  const { t } = useTranslation();
  const label =
    type === 'jobSize'
      ? t('agreements.job_size')
      : t('agreements.weekly_working_time');

  const labelId = type === 'jobSize' ? 'jobSize-hours' : 'perWeek-hours';

  return (
    <FormControl sx={{ flexBasis: '50%' }} required>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        label={label}
        labelId={labelId}
        value={value}
        renderValue={(selectValue) => `${selectValue} ${t('label.hours')}`}
        onChange={onChange}
        sx={{
          borderRadius: 0,
          borderTopLeftRadius: '1.2rem',
          borderBottomLeftRadius: '1.2rem',
        }}
      >
        {hourItemSteps.map((hour) => (
          <MenuItem key={hour} value={hour}>
            {hour}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
